import React, { Component } from "react";
import { Modal, Form, Col, Button, Card, Container, Row, Table } from "react-bootstrap";
import moment from "moment";


class FollowupHistoryModal extends Component {
    render() {
        console.log("history", this.props);
        return (
            <Modal
                {...this.props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton style={{ backgroundColor: "rgb(212,239,254)" }}>
                    <Modal.Title>History</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4" style={{ backgroundColor: "rgb(245,246,245)" }}>
                    <div style={{
                        width: '100%',
                        height: '400px',
                        overflow: 'auto',
                    }}>
                        {
                            this.props.stateData.individualHistoryData.map((item) => {
                                let followupDate = moment.unix(item.followUpDate).format("DD MMM YYYY h:mm a");
                                return (
                                    <div className="mt-2">
                                        <p className="font-weight-bold" style={{ fontSize: "20px", fontFamily: "Times New Roman" }}>{item.comments}</p>
                                        <p className="text-muted" style={{ fontSize: "15px", fontFamily: "Helvetica" }}>{followupDate} by {item.employee_name}</p><hr />
                                    </div>
                                )
                            })
                        }
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}
export default FollowupHistoryModal;